import { useEffect } from "react";

const androidStoreUrl =
  process.env.REACT_APP_PLAY_STORE_URL || "https://play.google.com/store/apps/details?id=com.theprimecare";
const iosStoreUrl =
  process.env.REACT_APP_APP_STORE_URL || "https://apps.apple.com/app/id6736359826";
const fallbackUrl =
  process.env.REACT_APP_DOWNLOAD_FALLBACK_URL || androidStoreUrl;

const getRedirectUrl = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isAndroid = /android/i.test(userAgent);
  const isIOS =
    /iPad|iPhone|iPod/.test(userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  if (isIOS) return iosStoreUrl;
  if (isAndroid) return androidStoreUrl;
  return fallbackUrl;
};

const AppStoreRedirect = () => {
  useEffect(() => {
    const redirectUrl = getRedirectUrl();
    window.location.replace(redirectUrl);
  }, []);

  return <div className="text-center mt-40">Redirecting to app store...</div>;
};

export default AppStoreRedirect;
